import { NavLink } from 'react-router';

export type NgBreadcrumbItemProps = {
  title?: string;
  to?: string;
  active?: boolean;
};

export function NgBreadcrumbItem({ title, to, active }: NgBreadcrumbItemProps) {
  const effectiveActiveClass = active ? 'active' : '';

  return (
    <li className={`breadcrumb-item ${effectiveActiveClass}`}>
      {to != null ? (
        <NavLink to={to} className={({ isActive }) => (isActive ? 'active' : undefined)}>
          {title}
        </NavLink>
      ) : (
        title
      )}
    </li>
  );
}
